
























import Vue from 'vue';
import { mapGetters } from "vuex";
import { FETCH_LAST_VIEWED_DEPOT, LAST_VIEWED_DEPOTS } from "@/common/store/modules/CommonStore";

export default Vue.extend({
  name: 'OctLastViewedDepots',
  computed: {
    LAST_VIEWED_DEPOTS() {
      return this.$store.getters['LAST_VIEWED_DEPOTS'];
    },
    noDepotsViewed(): boolean {
      return this.LAST_VIEWED_DEPOTS.length < 1;
    }
  },
  mounted(): void {
    this.$store.dispatch(FETCH_LAST_VIEWED_DEPOT);
  }
});
